module.exports = __webpack_public_path__ + "img/logo-min.3b6f1d11.svg";